import React from 'react';


export default function Download(props) {
    const {width, height} = props;
    const style = {
        margin: 'auto',
        display: 'block',
    };
  return (
    <svg style={style} width={width} height={height} viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <defs>
              <clipPath id="ldio-qb6o9yik32-cp" x="0" y="0" width="100" height="100">
                <circle cx="50" cy="50" r="28"></circle>
              </clipPath>
            </defs>
            <circle cx="50" cy="50" r="37" fill="#215d38" stroke="#14a651" stroke-width="6"></circle>
            <g clip-path="url(#ldio-qb6o9yik32-cp)">
              <g>
                <g transform="scale(0.5)">
                  <g transform="translate(-50,-50)">
                    <path fill="#e9eee8" d="M71.989,44.694V8.711c0-0.419-0.34-0.759-0.759-0.759H28.769c-0.419,0-0.759,0.34-0.759,0.759v35.983H6.069 c-0.914,0-1.405,1.075-0.807,1.766l43.931,45.22c0.425,0.491,1.188,0.491,1.613,0l43.931-45.22c0.599-0.691,0.108-1.766-0.807-1.766 H71.989z"></path>
                  </g>
                </g>
                <animateTransform attributeName="transform" type="translate" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="50 -20;50 120"></animateTransform>
              </g>
            </g>
        </svg>
  );
}

